<template>
  <div id="contenedor-listado-infraestructura-desktop">
    <v-data-table :headers="headers" :items="listadoInfraestructura" :items-per-page="20">
      <template v-slot:[`item.vidaUtilEstimados`]="{ item }">
        {{ getVidaUtilRestante(item) }}
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :infraestructura="item"></opciones>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoInfraestructuraDesktop',
  props: {
    listadoInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
      headers: [
        { text: 'Tipo', value: 'tipoInfraestructura.descripcion', align: 'start' },
        {
          text: 'Subtipo', value: 'subtipoInfraestructura.descripcion', align: 'start', sortable: false,
        },
        {
          text: 'Clave',
          value: 'clave',
          sortable: false,
        },
        {
          text: 'Descripción',
          align: 'start',
          value: 'descripcion',
          sortable: false,
        },
        {
          text: 'Dirección',
          align: 'start',
          value: 'direccion',
          sortable: false,
        },
        {
          text: 'Vida Útil Restante',
          align: 'center',
          value: 'vidaUtilEstimados',
        },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    getVidaUtilRestante(infraestructura) {
      if (!infraestructura.vidaUtilEstimados) return '';
      const tiempoTranscurrido = new Date().getFullYear()
        - new Date(infraestructura.fechaOrigen).getFullYear();
      const tiempoRestante = tiempoTranscurrido < infraestructura.vidaUtilEstimados
        ? infraestructura.vidaUtilEstimados - tiempoTranscurrido
        : 0;
      if (tiempoRestante === 0) return tiempoRestante;
      return tiempoRestante === 1 ? `${tiempoRestante} año` : `${tiempoRestante} años`;
    },
  },
};
</script>

<style lang="scss"></style>
